import type { CreateAnalysisPayload } from '@/features/ChatBot/interfaces';

import { parseAnalysisContent } from './parseAnalysisContent';

export const getCreateAnalysisPayload = (
  focusId: number,
  analysisText: string | null | undefined
): CreateAnalysisPayload => {
  const { title, description } = parseAnalysisContent(analysisText ?? '');

  return {
    focus: focusId,
    title,
    description: description,
    status: 'Draft',
  };
};
